import ProductCard from './ProductCard';

export default function ProductRecommendations({ products }) {
  if (!products.length) return null;

  return (
    <section className="recs-section">
      <div className="recs-header">
        <div>
          <p className="eyebrow">Complete the routine</p>
          <h2>You may also like</h2>
        </div>
      </div>
      <div className="grid catalog-grid">
        {products.map((product) => (
          <ProductCard product={product} key={product.slug} />
        ))}
      </div>
    </section>
  );
}
